(function () {
  function initDesktopMegaSlider(menu) {
    const slider = menu.querySelector('[data-custom-mega-slider]');
    const outer = menu.querySelector('.custom-mega-slider-outer');
    if (!slider || !outer) return;

    const next = outer.querySelector('.custom-mega-arrow--next');
    const prev = outer.querySelector('.custom-mega-arrow--prev');
    if (!next || !prev) return;

    function updateArrows() {
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      const canScroll = maxScroll > 1;

      if (!canScroll) {
        prev.classList.add('is-hidden');
        next.classList.add('is-hidden');
        prev.disabled = true;
        next.disabled = true;
        return;
      }

      const atStart = slider.scrollLeft <= 1;
      const atEnd = slider.scrollLeft >= maxScroll - 1;

      prev.classList.toggle('is-hidden', atStart);
      next.classList.toggle('is-hidden', atEnd);
      prev.disabled = atStart;
      next.disabled = atEnd;
    }

    next.addEventListener('click', function () {
      if (next.disabled) return;
      slider.scrollBy({ left: slider.clientWidth, behavior: 'smooth' });
    });

    prev.addEventListener('click', function () {
      if (prev.disabled) return;
      slider.scrollBy({ left: -slider.clientWidth, behavior: 'smooth' });
    });

    slider.addEventListener('scroll', updateArrows, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateArrows).observe(slider);
    } else {
      window.addEventListener('resize', updateArrows);
    }

    const flyoutItem = menu.closest('.header-nav-ar__item.has-megamenu');
    if (flyoutItem) {
      flyoutItem.addEventListener('mouseenter', updateArrows);
    }

    updateArrows();
    requestAnimationFrame(updateArrows);
  }

  function init() {
    document.querySelectorAll('[data-custom-mega-menu]').forEach(initDesktopMegaSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
